module.exports = __webpack_public_path__ + "img/logo2_1.7a1fbdba.png";